import React from "react";
import './overall-baseline-finishline-report.scss';
import SchoolApi from "../../../../apis/school";
import Loading from "../../../common/loading/loading";
import { getImageSource } from "../../../../utility/image-source";
import { ImageConstants } from "../../../../constants/constants";
import SessionCache from "../../../routes/session-cache";

class OverallBaselineFinishlineReport extends React.Component {

    state = {
        isLoading: false,
        isDownloading: false,
        reportData: null,
        userInfo: {}
    }

    componentDidMount() {
        const userInfo = SessionCache.getUser();
        this.setState({ userInfo });
        this.fetchReport();
    }

    fetchReport = () => {
        const { selectedItem } = this.props;
        if (!selectedItem) return;

        const chapterName = Array.isArray(selectedItem.chapters) && selectedItem.chapters.length > 0
            ? (typeof selectedItem.chapters[0] === 'object'
                ? (selectedItem.chapters[0].title || selectedItem.chapters[0].name || '')
                : selectedItem.chapters[0])
            : (selectedItem.chapterTitle || selectedItem.chapterName || selectedItem.chapter || '');

        const payload = {};
        if (selectedItem.board) payload.board = selectedItem.board;
        if (selectedItem.class) payload.class = selectedItem.class;
        if (chapterName) payload.chapterName = chapterName;
        // For the overall report, we also need the masterDataId or homeworkId depending on backend, but let's send what the original sends minus section.
        if (selectedItem.homeworkId) payload.homeworkId = selectedItem.homeworkId;

        this.setState({ isLoading: true });

        SchoolApi.getOverallBaselineFinishlineReport(payload)
            .then(res => {
                if (res && res.metadata) {
                    this.setState({ reportData: res, isLoading: false });
                } else {
                    this.setState({ isLoading: false });
                }
            })
            .catch(err => {
                console.error('[OverallBaselineFinishlineReport] Error:', err);
                this.setState({ isLoading: false });
            });
    }

    onClickBack = () => {
        this.props.delegate && this.props.delegate.hideOverallPerformanceReport && this.props.delegate.hideOverallPerformanceReport();
    }

    downloadPDF = () => {
        const { selectedItem } = this.props;
        if (!selectedItem) return;

        const chapterName = Array.isArray(selectedItem.chapters) && selectedItem.chapters.length > 0
            ? (typeof selectedItem.chapters[0] === 'object'
                ? (selectedItem.chapters[0].title || selectedItem.chapters[0].name || '')
                : selectedItem.chapters[0])
            : (selectedItem.chapterTitle || selectedItem.chapterName || selectedItem.chapter || '');

        const payload = { format: 'pdf' };
        if (selectedItem.board) payload.board = selectedItem.board;
        if (selectedItem.class) payload.class = selectedItem.class;
        if (chapterName) payload.chapterName = chapterName;
        if (selectedItem.homeworkId) payload.homeworkId = selectedItem.homeworkId;

        this.setState({ isDownloading: true });

        SchoolApi.getOverallBaselineFinishlineReport(payload)
            .then(res => {
                this.setState({ isDownloading: false });
                if (res && res.success && res.pdfLink) {
                    window.open(res.pdfLink, "_blank");
                }
            })
            .catch(err => {
                console.error('[OverallBaselineFinishlineReport] Error downloading PDF:', err);
                this.setState({ isDownloading: false });
            });
    }

    renderBadge(gain) {
        if (gain === null || gain === undefined) return null;
        if (gain > 0) return <div className="badge badge-up">▲ +{Number(gain).toFixed(2)}% relative</div>;
        if (gain < 0) return <div className="badge badge-down">▼ {Number(gain).toFixed(2)}% relative</div>;
        return <div className="badge pill-stayed">0% change</div>;
    }

    renderGainText(gain) {
        if (gain === null || gain === undefined) return '-';
        const isPos = gain > 0;
        const isNeg = gain < 0;
        if (!isPos && !isNeg) return <span style={{ color: '#6b7280', fontWeight: '600' }}>-</span>;
        const color = isPos ? '#059669' : '#dc2626';
        const arrow = isPos ? '▲' : '▼';
        const text = (isPos ? '+' : '') + Number(gain).toFixed(2) + '%';
        return (
            <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'flex-start', width: '85px', color, fontWeight: '600' }}>
                <span style={{ width: '14px', textAlign: 'left', flexShrink: 0 }}>{arrow}</span>
                <span>{text}</span>
            </span>
        );
    }

    renderDonut(percent, type) {
        if (percent === null || percent === undefined) percent = 0;
        const color = type === 'baseline' ? '#fed7aa' : '#3b82f6';
        return (
            <div className={`donut donut-${type}`} style={{ background: `conic-gradient(${color} 0% ${percent}%, #f3f4f6 ${percent}% 100%)` }}>
                <div className="donut-inner">{Number(percent).toFixed(2)}%</div>
            </div>
        );
    }

    formatPct(val) {
        if (val === null || val === undefined) return '-';
        return `${Number(val).toFixed(2)}%`;
    }

    getDotClass(band) {
        if (band === 'Novice') return 'red';
        if (band === 'Intermediate') return 'yellow';
        if (band === 'Advanced') return 'green';
        return 'yellow';
    }

    render() {
        const { selectedItem } = this.props;
        const { isLoading, isDownloading, reportData, userInfo } = this.state;

        return (
            <div className="baseline-report-wrapper">
                {isLoading && <Loading />}

                <div className="d-flex align-items-center mb-3">
                    <div>
                        <img alt="back" className='back-icon cursor-pointer' style={{ width: '35px' }} src={getImageSource(ImageConstants.BACK_ICON)} onClick={this.onClickBack} />
                    </div>
                </div>

                <div className="title">Overall Baseline vs Finishline Report</div>

                <div className="mb-4 d-flex justify-content-between align-items-center">
                    <div className="subtitle">{userInfo?.schoolInfo?.name}</div>
                    {reportData && (
                        <div className={`export-button cursor-pointer ${isDownloading ? 'downloading' : ''}`} onClick={isDownloading ? undefined : this.downloadPDF}>
                            <svg className="download-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
                                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                <polyline points="7 10 12 15 17 10"></polyline>
                                <line x1="12" y1="15" x2="12" y2="3"></line>
                            </svg>
                            {isDownloading ? 'Downloading...' : 'Download Report'}
                        </div>
                    )}
                </div>

                {!isLoading && !reportData && (
                    <div className="p-4" style={{ color: '#6b7280' }}>
                        No data found. Please ensure both Baseline and Finishline assessments exist for Class {selectedItem && selectedItem.class} with matching chapter.
                    </div>
                )}

                {!isLoading && reportData && (() => {
                    const { metadata, kpis, cohortRelativeGain, cohortMigration, studentMovement } = reportData;
                    if (!kpis) return <div className="p-4" style={{ color: '#6b7280' }}>No report data available.</div>;
                    return (
                        <div className="container-fluid p-0">

                            {/* Details fieldset */}
                            <fieldset className="details-fieldset">
                                <legend>Details</legend>
                                <div className="details-flex-container">
                                    <div className="details-info-side" style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', gap: '0.5rem 2rem', alignItems: 'center' }}>
                                        <div style={{ color: '#6b7280', fontWeight: '500' }}>Class</div>
                                        <div style={{ fontWeight: '600' }}>{selectedItem?.class || '-'}</div>

                                        <div style={{ color: '#6b7280', fontWeight: '500' }}>Section(s)</div>
                                        <div style={{ fontWeight: '600' }}>{metadata?.sectionName || 'All Sections'}</div>

                                        <div style={{ color: '#6b7280', fontWeight: '500' }}>Subject</div>
                                        <div style={{ fontWeight: '600' }}>{metadata?.subject?.split('·')[0]?.trim()}</div>

                                        <div style={{ color: '#6b7280', fontWeight: '500' }}>Chapter</div>
                                        <div style={{ fontWeight: '600' }}>{metadata?.subject?.split('·')[1]?.trim()}</div>

                                        <div style={{ color: '#6b7280', fontWeight: '500' }}>Students</div>
                                        <div style={{ fontWeight: '600' }}>{cohortMigration?.summary?.total || 0} (took both)</div>
                                    </div>
                                    <div className="details-kpi-side">
                                        {[
                                            { label: 'Question Accuracy', key: 'questionAccuracy' },
                                            { label: 'Overall Score', key: 'overallScore' },
                                            { label: 'Competency Questions', key: 'competencyQuestions' }
                                        ].map(({ label, key }) => (
                                            <div className="kpi-group-inline" key={key}>
                                                <div className="kpi-title">{label}</div>
                                                <div className="donut-container">
                                                    <div className="donut-wrapper">{this.renderDonut(kpis[key].baseline, 'baseline')} Baseline</div>
                                                    <div className="donut-wrapper">{this.renderDonut(kpis[key].finishline, 'finishline')} Finishline</div>
                                                </div>
                                                {this.renderBadge(kpis[key].relativeGain)}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </fieldset>

                            {/* Cohort Relative Gain */}
                            <fieldset className="details-fieldset">
                                <legend>Cohort Relative Gain</legend>
                                <div className="migration-summary" style={{ color: '#6b7280', marginBottom: '1rem' }}>Cohorts fixed at baseline score</div>
                                <div className="table-responsive">
                                    <table className="table mb-0" style={{ tableLayout: 'fixed' }}>
                                        <colgroup>
                                            <col style={{ width: '25%' }} /><col style={{ width: '15%' }} /><col style={{ width: '20%' }} /><col style={{ width: '20%' }} /><col style={{ width: '20%' }} />
                                        </colgroup>
                                        <thead className="class-header">
                                            <tr className="first-header-bg">
                                                <th>Cohort (baseline score)</th><th>Students</th><th>Baseline avg</th><th>Finishline avg</th><th style={{ textAlign: 'right' }}>Relative gain</th>
                                            </tr>
                                        </thead>
                                        <tbody className="class-body">
                                            {cohortRelativeGain && cohortRelativeGain.map(cohort => (
                                                <tr key={cohort.cohort}>
                                                    <td>{cohort.cohort} {cohort.cohort === 'Novice' ? '(< 50%)' : cohort.cohort === 'Intermediate' ? '(50-70%)' : '(71%+)'}</td>
                                                    <td>{cohort.students}</td>
                                                    <td>{this.formatPct(cohort.baselineAvg)}</td>
                                                    <td><b>{this.formatPct(cohort.finishlineAvg)}</b></td>
                                                    <td style={{ textAlign: 'right' }}>{this.renderGainText(cohort.relativeGain)}</td>
                                                </tr>
                                            ))}
                                            <tr className="total-row">
                                                <td>Total</td>
                                                <td>{cohortMigration.summary.total}</td>
                                                <td>{this.formatPct(kpis.overallScore.baseline)}</td>
                                                <td>{this.formatPct(kpis.overallScore.finishline)}</td>
                                                <td style={{ textAlign: 'right' }}>{this.renderGainText(kpis.overallScore.relativeGain)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </fieldset>

                            {/* Cohort Migration */}
                            <fieldset className="details-fieldset">
                                <legend>Cohort Migration</legend>
                                <div className="migration-summary" style={{ marginBottom: '1rem' }}>
                                    <span style={{ color: '#059669' }}>▲ moved up  band(s)</span>&nbsp;·&nbsp;<span style={{ color: '#dc2626' }}>▼ moved down  band(s)</span>
                                </div>
                                {['Novice', 'Intermediate', 'Advanced'].map(bandName => {
                                    const band = cohortMigration.bands[bandName];
                                    if (!band) return null;
                                    let changeColor = band.change > 0 ? '#059669' : band.change < 0 ? '#dc2626' : '#6b7280';
                                    if (bandName === 'Novice') {
                                        changeColor = band.change > 0 ? '#dc2626' : band.change < 0 ? '#059669' : '#6b7280';
                                    } else if (bandName === 'Intermediate') {
                                        let goodMoves = 0;
                                        let badMoves = 0;
                                        (band.left || []).forEach(l => {
                                            let d = l.dir || l.direction;
                                            if (d === 'up') goodMoves += parseInt(l.label) || 0;
                                            else if (d === 'down') badMoves += parseInt(l.label) || 0;
                                        });
                                        (band.joined || []).forEach(j => {
                                            let d = j.dir || j.direction;
                                            if (d === 'up') goodMoves += parseInt(j.label) || 0;
                                            else if (d === 'down') badMoves += parseInt(j.label) || 0;
                                        });
                                        if (goodMoves > badMoves) changeColor = '#059669';
                                        else if (badMoves > goodMoves) changeColor = '#dc2626';
                                        else changeColor = '#6b7280';
                                    }
                                    const changeText = band.change === 0 || changeColor === '#6b7280'
                                        ? 'no change'
                                        : changeColor === '#059669'
                                            ? `▲ ${Math.abs(band.change)}`
                                            : `▼ ${Math.abs(band.change)}`;
                                    return (
                                        <div className="migration-band" key={bandName}>
                                            <div className="migration-left">
                                                <h4>{bandName}</h4>
                                                <div className="migration-numbers">{band.start} → {band.end} <span style={{ color: changeColor }}>{changeText}</span></div>
                                                <div className="migration-math">{band.start} - {band.leftCount} + {band.joinedCount} = {band.end}</div>
                                            </div>
                                            <div className="migration-right">
                                                <div className="migration-row"><div className="migration-label">Stayed</div><div className="migration-items"><div className="pill pill-stayed">{band.stayed} stayed in {bandName}</div></div></div>
                                                <div className="migration-row"><div className="migration-label">Left</div><div className="migration-items">
                                                    {band.left.map((l, i) => <div key={i} className={`pill ${l.dir === 'up' ? 'badge-up' : 'badge-down'}`}>{l.dir === 'up' ? '▲' : '▼'} {l.label}</div>)}
                                                    {band.left.length === 0 && <div className="pill pill-stayed">0 left</div>}
                                                </div></div>
                                                <div className="migration-row"><div className="migration-label">Joined</div><div className="migration-items">
                                                    {band.joined.map((j, i) => <div key={i} className={`pill ${j.dir === 'up' ? 'badge-up' : 'badge-down'}`}>{j.dir === 'up' ? '▲' : '▼'} {j.label}</div>)}
                                                    {band.joined.length === 0 && <div className="pill pill-stayed">0 joined</div>}
                                                </div></div>
                                            </div>
                                        </div>
                                    );
                                })}
                                <div className="migration-footer">
                                    <div>Whole class · {cohortMigration.summary.total} students</div>
                                    <div className="footer-stats">
                                        <span style={{ color: '#059669' }}>▲ {cohortMigration.summary.movedUp} moved up</span>
                                        <span style={{ color: '#6b7280' }}>{cohortMigration.summary.sameBand} same band</span>
                                        <span style={{ color: '#dc2626' }}>▼ {cohortMigration.summary.movedDown} moved down</span>
                                    </div>
                                </div>
                            </fieldset>

                            {/* Student Movement */}
                            <div style={{ marginTop: '3rem', paddingTop: '2rem', borderTop: '1px dashed #d1d5db' }}></div>
                            <fieldset className="details-fieldset">
                                <legend>Student Movement Detail</legend>
                                <div className="movement-summary-bar">
                                    <div className="summary-left">Students who changed band <span className="summary-divider">|</span> {cohortMigration.summary.movedUp + cohortMigration.summary.movedDown} of {cohortMigration.summary.total}</div>
                                    <div className="summary-right">
                                        <span className="summary-down">▼ {cohortMigration.summary.movedDown} moved down</span>
                                        <span className="summary-up">▲ {cohortMigration.summary.movedUp} moved up</span>
                                    </div>
                                </div>
                                {['movedDown', 'movedUp'].map(dir => {
                                    const isDown = dir === 'movedDown';
                                    const groups = studentMovement[dir];
                                    return (
                                        <div key={dir} className={`movement-card theme-${isDown ? 'down' : 'up'}`}>
                                            <div className="movement-header"><h4>{isDown ? 'Moved Down' : 'Moved Up'}</h4></div>
                                            <div className="movement-body">
                                                {groups.length === 0 && <p style={{ color: '#6b7280', margin: 0 }}>No students {isDown ? 'moved down' : 'moved up'}.</p>}
                                                {groups.map((group, idx) => (
                                                    <div key={idx} className="movement-group">
                                                        <div className="movement-group-title">
                                                            <div className={`tag ${isDown ? 'tag-red' : 'tag-green'}`}>{isDown ? '▼' : '▲'} {group.category}</div>
                                                            <span className="count">{group.students.length} student{group.students.length !== 1 ? 's' : ''}</span>
                                                        </div>
                                                        <table className="movement-table">
                                                            <thead><tr>
                                                                <th className="align-left" style={{ width: '40%' }}>Student</th>
                                                                <th className="align-center" style={{ width: '20%' }}>Baseline</th>
                                                                <th className="align-center" style={{ width: '20%' }}>Finishline</th>
                                                                <th className="align-right" style={{ width: '20%' }}>Relative gain</th>
                                                            </tr></thead>
                                                            <tbody>
                                                                {group.students.length > 0 ? group.students.map((student, i) => (
                                                                    <tr key={i}>
                                                                        <td className="align-left">{student.name}</td>
                                                                        <td className="align-center">{this.formatPct(student.baseline)}</td>
                                                                        <td className="align-center font-bold">{this.formatPct(student.finishline)}</td>
                                                                        <td className="align-right">{this.renderGainText(student.relativeGain)}</td>
                                                                    </tr>
                                                                )) : (
                                                                    <tr><td colSpan="4" className="align-center" style={{ color: '#6b7280', padding: '1.5rem', fontStyle: 'italic' }}>No students in this group.</td></tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    );
                                })}
                            </fieldset>
                        </div>
                    );
                })()}
            </div>
        );
    }
}

export default OverallBaselineFinishlineReport;
